import tw from "twin.macro";
import { getThemeStyle, type Mode } from "~/features/ui/get-theme-style";

type Props = {
  mode: Mode;
  text: string;
};

export function Eyebrow(props: Props) {
  const { mode = "light", text, ...rest } = props;
  const themeStyle = getThemeStyle({ mode: mode as Mode });

  return (
    <p
      css={[tw`text-mobile-caption-30-normal lg:text-desktop-caption-30-normal font-aeonik`, themeStyle.label]}
      {...rest}
    >
      {text}
    </p>
  );
}
